import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BrandListRow } from './brand-list-row.model';

/**
 * Name-column cell for the unified Brands list. A brand row renders its plain
 * name; a sub-brand row renders an indented "↳ {name}" in muted text followed by
 * a small "Sub-brand" badge so the hierarchy reads at a glance without surfacing
 * sub-brand-specific columns.
 */
@Component({
  selector: 'cmt-brand-row-name-cell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (row(); as r) {
      @if (r.type === 'subbrand') {
        <span class="inline-flex min-w-0 items-center gap-2">
          <span class="truncate text-muted-foreground">
            <span class="mr-1 text-muted-foreground/60" aria-hidden="true">&#8627;</span>{{ r.name }}
          </span>
          <span class="cmt-eyebrow flex-none rounded-md border border-border bg-muted/60 px-1.5 py-0.5 text-xs">
            Sub-brand
          </span>
        </span>
      } @else {
        <span class="truncate font-medium text-foreground">{{ r.name }}</span>
      }
    }
  `,
  styles: [`:host { display: flex; align-items: center; height: 100%; min-width: 0; }`],
})
export class BrandRowNameCellComponent implements ICellRendererAngularComp {
  protected readonly row = signal<BrandListRow | null>(null);

  agInit(params: ICellRendererParams<BrandListRow>): void {
    this.row.set(params.data ?? null);
  }

  refresh(params: ICellRendererParams<BrandListRow>): boolean {
    this.row.set(params.data ?? null);
    return true;
  }
}
